import { LegalLayout, Section, Li, B } from "../components/LegalLayout";

const UPDATED = "June 1, 2026";

export default function TermsOfUse() {
  return (
    <LegalLayout title="Terms of Use" updated={UPDATED}>
      <p className="text-slate-300">
        These Terms of Use ("Terms") govern your access to and use of PNR Decode. By creating an account or using
        the service, you agree to be bound by these Terms. If you do not agree, please do not use PNR Decode.
      </p>

      <Section heading="1. Acceptance of Terms">
        <p>
          By accessing or using the service you confirm that you are at least 18 years old (or the age of majority
          in your jurisdiction) and have the authority to enter into these Terms on behalf of yourself or your
          organisation.
        </p>
      </Section>

      <Section heading="2. Description of Service">
        <p>
          PNR Decode converts raw GDS itinerary text (such as Sabre and Amadeus) into clean, human-readable and
          brandable flight itineraries, with layouts, exports, shareable links and an optional public API. Features
          available to you depend on your subscription plan.
        </p>
      </Section>

      <Section heading="3. User Responsibilities">
        <ul className="space-y-2">
          <Li>Provide accurate account information and keep your credentials secure.</Li>
          <Li>Ensure you have the right to process any traveller or booking data you input.</Li>
          <Li>Use the service in compliance with all applicable laws and airline/GDS agreements.</Li>
          <Li>You are responsible for all activity that occurs under your account and API keys.</Li>
        </ul>
      </Section>

      <Section heading="4. Prohibited Activities">
        <p>You agree not to:</p>
        <ul className="space-y-2">
          <Li>Reverse engineer, scrape, overload or attempt to disrupt the service or its infrastructure.</Li>
          <Li>Exceed the usage or rate limits of your plan, or share/resell API keys without authorisation.</Li>
          <Li>Upload unlawful, infringing or malicious content, or violate the privacy or rights of others.</Li>
          <Li>Use the service to send spam or for any fraudulent or deceptive purpose.</Li>
        </ul>
      </Section>

      <Section heading="5. Intellectual Property">
        <p>
          The PNR Decode name, logo, software, design, layouts and content are owned by PNR Decode and protected by
          intellectual property laws. We grant you a limited, non-exclusive, non-transferable licence to use the
          service. You retain ownership of the itinerary content and branding assets you provide.
        </p>
      </Section>

      <Section heading="6. Limitation of Liability">
        <p>
          The service is provided "as is" and "as available" without warranties of any kind. To the maximum extent
          permitted by law, PNR Decode is not liable for any indirect, incidental or consequential damages, or for
          any loss of data, profits or bookings arising from your use of — or inability to use — the service. Our
          total liability shall not exceed the amount you paid us in the 12 months preceding the claim.
        </p>
      </Section>

      <Section heading="7. Termination">
        <p>
          You may stop using the service and delete your account at any time. We may suspend or terminate your
          access if you breach these Terms or use the service in a way that harms us or other users. Provisions that
          by their nature should survive termination (e.g. intellectual property, liability) will remain in effect.
        </p>
      </Section>

      <Section heading="8. Governing Law">
        <p>
          These Terms are governed by the laws of the jurisdiction in which PNR Decode operates, without regard to
          conflict-of-law principles. Any disputes will be subject to the exclusive jurisdiction of the competent
          courts of that jurisdiction.
        </p>
      </Section>

      <Section heading="9. Contact">
        <p>Questions about these Terms? Email <B>support@pnrdecode.com</B>.</p>
      </Section>
    </LegalLayout>
  );
}
